import { render, staticRenderFns } from "./Offertes.vue?vue&type=template&id=50591d81"
import script from "./Offertes.vue?vue&type=script&lang=js"
export * from "./Offertes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports